import { NETWORK_PROBLEM, Problem } from '@sportik/api-coach/problem';

/**
 * What a failed API call says on screen, chosen by the problem's stable `code`
 * (ADR 0003), never by its message. A code without copy of its own, the
 * client's `unknown` included, gets the general one.
 */
export function problemCopy(code: string) {
  switch (code) {
    case 'coach_entitlement_required':
      return {
        title: 'This account has no coach access',
        description: 'Sign in with a coach account to use this app.',
      };
    case 'signup_not_allowed':
      return {
        title: 'This account cannot use this app',
        description:
          'This Google account may not sign up here. Sign out and use the account you were invited with.',
      };
    case 'email_not_verified':
      return {
        title: 'This address is not verified',
        description:
          'Google has not verified this account’s email address. Verify it, then sign in again.',
      };
    case 'account_exists':
      return {
        title: 'This address belongs to another account',
        description:
          'Another account already uses this Google account’s email address. Sign out and use the account you signed up with.',
      };
    case NETWORK_PROBLEM:
      return {
        title: 'Cannot reach the server',
        description: 'Check the connection and try again.',
      };
    default:
      return {
        title: 'Something went wrong',
        description: 'The server could not complete this. Try again.',
      };
  }
}

/**
 * What a failed write says beside the text the coach typed, which stays. A
 * version conflict gets the widget's own sentence: what changed, and what is
 * shown now.
 */
export function writeProblem(error: unknown, conflict: string) {
  if (error instanceof Problem && error.code === 'version_conflict') {
    return conflict;
  }
  const { title, description } = problemCopy(
    error instanceof Problem ? error.code : '',
  );
  return `${title}. ${description} Your text is kept.`;
}
